// Centralized route paths and helpers
export var routes = {
    home: '/',
    login: '/login',
    signup: '/signup',
    documents: '/documents',
    exam: '/exam',
    cookiePolicy: '/cookie-policy',
    // Exam Boards
    examBoards: '/exam-boards',
    examBoard: function (boardId) { return "/exam-boards/".concat(boardId); },
    examBoardNotes: function (boardId) { return "/exam-boards/".concat(boardId, "/notes"); },
    examBoardPractice: function (boardId) { return "/exam-boards/".concat(boardId, "/practice"); },
    examBoardMocks: function (boardId) { return "/exam-boards/".concat(boardId, "/mocks"); },
    examBoardSubject: function (boardId, subjectId) { return "/exam-boards/".concat(boardId, "/").concat(subjectId); },
    examBoardSubjectNotes: function (boardId, subjectId) { return "/exam-boards/".concat(boardId, "/").concat(subjectId, "/notes"); },
    examBoardSubjectPractice: function (boardId, subjectId) { return "/exam-boards/".concat(boardId, "/").concat(subjectId, "/practice"); },
    examBoardSubjectMocks: function (boardId, subjectId) { return "/exam-boards/".concat(boardId, "/").concat(subjectId, "/mocks"); },
    // Document sessions - all use enhanced analysis
    session: function (id) { return "/documents/".concat(id, "/analysis"); },
    documentAnalysis: function (documentId) { return "/documents/".concat(documentId, "/analysis"); },
    // Exam sessions
    examSessions: '/exam/sessions',
    examSession: function (id) { return "/exam/sessions/".concat(id); },
    examSessionPractice: function (id) { return "/exam/sessions/".concat(id, "/practice"); },
    examSessionReview: function (id) { return "/exam/sessions/".concat(id, "/review"); },
    examSessionExam: function (id) { return "/exam/sessions/".concat(id, "/exam"); },
};
export var pageToPath = function (page) {
    switch (page) {
        case 'welcome':
            return routes.home;
        case 'documents':
            return routes.documents;
        case 'exam':
            return routes.exam;
        case 'exam-boards':
            return routes.examBoards;
        default:
            return routes.home;
    }
};
export var pathToPage = function (pathname) {
    if (pathname.startsWith('/documents')) {
        return 'documents';
    }
    if (pathname.startsWith('/exam-boards')) {
        return 'exam-boards';
    }
    if (pathname.startsWith('/exam')) {
        return 'exam';
    }
    return 'welcome';
};
